import { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { useApi } from "@/lib/api";
import { Page, Spinner, Empty, UserAvatar } from "@/components/common";
import { Input } from "@/components/ui/input";

const CreatorTile = ({ c, upcoming, i }) => (
  <Link to={`/creators/${c.id}`} data-testid={`creator-card-${c.id}`} style={{ animationDelay: `${i * 60}ms` }}
    className="rise group flex flex-col items-start p-6 rounded-3xl bg-white border border-stone-200 hover:border-stone-900 transition-colors">
    <UserAvatar user={c} className="h-20 w-20" />
    <p className="mt-4 font-display text-2xl font-bold group-hover:text-[#FF5C00] transition-colors">{c.name}</p>
    <p className="text-sm text-stone-500">{c.city || "Local creator"}</p>
    {c.bio && <p className="mt-3 text-sm text-stone-600 line-clamp-2">{c.bio}</p>}
    {upcoming != null && <span className="mt-4 font-mono text-xs bg-orange-50 text-[#C2410C] border border-orange-200 px-2.5 py-1 rounded-full">{upcoming} upcoming</span>}
  </Link>
);

export default function Creators() {
  const [q, setQ] = useState("");
  const { data: top, isLoading } = useApi("/creators/top");
  const { data: search } = useApi(q.length > 1 ? `/users/search?q=${encodeURIComponent(q)}` : null);
  const found = (search?.users || []).filter((u) => u.approved);
  return (
    <Page>
      <p className="font-mono text-xs uppercase tracking-widest text-stone-500">Community</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Creators</h1>
      <div className="relative mt-8 max-w-md">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
        <Input data-testid="creators-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members" className="pl-10 h-11 rounded-2xl bg-white" />
      </div>
      <div className="mt-10">
        {q.length > 1 ? (
          found.length ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">{found.map((u, i) => <CreatorTile key={u.id} c={u} i={i} />)}</div>
          ) : <Empty title="No one found" />
        ) : isLoading ? <Spinner /> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {(top?.creators || []).map((t, i) => <CreatorTile key={t.creator.id} c={t.creator} upcoming={t.upcoming_count} i={i} />)}
          </div>
        )}
      </div>
    </Page>
  );
}
